import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const EmailIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "EmailIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M19.4396 19.8774H4.56071C3.1486 19.8774 2.00016 18.729 2.00016 17.3169V6.68311C2.00016 5.271 3.1486 4.12207 4.56071 4.12207H19.4396C20.8517 4.12207 22.0002 5.271 22.0002 6.68311V17.3169C22.0002 18.729 20.8517 19.8774 19.4396 19.8774ZM4.56071 5.12208C3.70036 5.12208 3.00016 5.82228 3.00016 6.68312V17.3169C3.00016 18.1773 3.70036 18.8775 4.56071 18.8775H19.4396C20.3 18.8775 21.0002 18.1773 21.0002 17.3169V6.68311C21.0002 5.82227 20.3 5.12207 19.4396 5.12207L4.56071 5.12208Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.0002 13.2075C11.9069 13.2075 11.8141 13.1817 11.7326 13.1299L2.23258 7.10548C1.99918 6.95753 1.92985 6.64845 2.07779 6.41554C2.22525 6.18214 2.53531 6.11232 2.76773 6.26075L12.0002 12.1152L21.2326 6.26075C21.4655 6.11231 21.7746 6.18214 21.9225 6.41554C22.0705 6.64845 22.0011 6.95753 21.7677 7.10548L12.2677 13.1299C12.1862 13.1817 12.0934 13.2075 12.0002 13.2075Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default EmailIcon;
